import { useEffect, useState } from "react";
import { getRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Spin } from "antd";
import LoginFormV2 from "./LoginFormV2";
import "./LoginV2.scss";

const LoginV2 = () => {
  const location = useLocation();
  const urlPartner = location.pathname.split("/")[2];
  const partnerID = urlPartner.replace(/_/g, " ");

  const [partnerData, setPartnerData] = useState(null);
  const [loading, setLoading] = useState(false);

  localStorage.setItem("loginPage", "true");
  localStorage.setItem("partnerID", partnerID);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const subDomain = await getRequest(
          userServiceApi.getSubDomainDetails(partnerID)
        );

        if (subDomain?.data?.subDomainName) {
          const details = await getRequest(
            userServiceApi.getPartnerDetailsLoginScreen(
              subDomain.data.subDomainName
            )
          );

          setPartnerData(details?.data);
          localStorage.setItem("partner", details?.data?.subDomainName);
        }
      } catch (error) {
        toast.error(error.error);
      } finally {
        setLoading(false);
      }
    };

    if (partnerID) fetchData();
  }, [partnerID]);

  if (loading) {
    return (
      <div className="login-v2-loading-spinner">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="login-v2-main-wrapper">
      <div
        style={{
          backgroundImage: `linear-gradient(45deg,rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)), url(${partnerData?.wallpaper})`,
        }}
        className="login-v2-partner-image"
      >
        {partnerData?.showSiteName && (
        <div className="login-v2-partner-overlay">
          <div className="login-v2-partner-name">{partnerData?.siteName}</div>
          <div className="login-v2-partner-description">
            {partnerData?.description}
          </div>
        </div>
        )}
      </div>
      <div className="login-v2-login-form">
        <LoginFormV2 partnerData={partnerData} />
      </div>
    </div>
  );
};

export default LoginV2;
